module.exports = __webpack_public_path__ + "img/Paragon Logo.19df2086.png";